import { getCapitalizedString } from './strings';

export function getEntityName(entity, currUser) {
  return (
    (currUser && currUser.entities && currUser.entities[entity]) ||
    getCapitalizedString(entity)
  );
}
